// extracted by mini-css-extract-plugin
module.exports = {"foundArticles":"styles_foundArticles__m4XQE","input":"styles_input__LAuLb","nothingFound":"styles_nothingFound__pzrQ_"};